export { default as FilesWidget } from "./files_widget";
import * as FilesWidgetFactory from "./files_widget_factory";

export { FilesWidgetFactory };
